// Thu Mar 27 06:04:36 GMT 2025

import * as models from "../crm-web-api-models"

export enum ActivityProp {
	CreationTime = 'creationTime',
	CustomerId = 'customer.id',
	Description = 'description',
	Direction = 'direction',
	Id = 'id',
	Medium = 'medium',
	ModificationTime = 'modificationTime',
	ModifiedBy = 'modifiedBy',
	Outcome = 'outcome',
	OutcomeLabel = 'outcome.label',
	OutcomeValue = 'outcome.value',
	RelatedEntity = 'relatedEntity',
	RelatedEntityId = 'relatedEntity.id',
	Summary = 'summary'
}

export type ActivityPropCreationTime = {
	[ActivityProp.CreationTime] : number | null
}
export type ActivityPropCustomerId = {
	[ActivityProp.CustomerId] : number | null
}
export type ActivityPropDescription = {
	[ActivityProp.Description] : string | null
}
export type ActivityPropDirection = {
	[ActivityProp.Direction] : 'NONE' | 'INCOMING' | 'OUTGOING' | null
}
export type ActivityPropId = {
	[ActivityProp.Id] : number
}
export type ActivityPropMedium = {
	[ActivityProp.Medium] : 'INTERNAL' | 'MAIL' | 'PHONE' | 'LIVE_CHAT' | 'SMS' | 'MEETING' | 'ZENDESK' | 'APP_POPUP' | 'APP_PUSH' | 'RECORDING' | 'ZENDESK_CHAT' | null
}
export type ActivityPropModificationTime = {
	[ActivityProp.ModificationTime] : number | null
}
export type ActivityPropModifiedBy = {
	[ActivityProp.ModifiedBy] : models.UserDto
}
export type ActivityPropOutcome = {
	[ActivityProp.Outcome] : any /* Entity */
}
export type ActivityPropOutcomeLabel = {
	[ActivityProp.OutcomeLabel] : string | null
}
export type ActivityPropOutcomeValue = {
	[ActivityProp.OutcomeValue] : string | null
}
export type ActivityPropRelatedEntity = {
	[ActivityProp.RelatedEntity] : any /* Entity */
}
export type ActivityPropRelatedEntityId = {
	[ActivityProp.RelatedEntityId] : number | null
}
export type ActivityPropSummary = {
	[ActivityProp.Summary] : string | null
}


export type Activity = 
	ActivityPropCreationTime & 
	ActivityPropCustomerId & 
	ActivityPropDescription & 
	ActivityPropDirection & 
	ActivityPropId & 
	ActivityPropMedium & 
	ActivityPropModificationTime & 
	ActivityPropModifiedBy & 
	ActivityPropOutcome & 
	ActivityPropOutcomeLabel & 
	ActivityPropOutcomeValue & 
	ActivityPropRelatedEntity & 
	ActivityPropRelatedEntityId & 
	ActivityPropSummary

export const ACTIVITY_PROPERTY_NAMES = Object.freeze([ActivityProp.CreationTime, ActivityProp.CustomerId, ActivityProp.Description, ActivityProp.Direction, ActivityProp.Id, ActivityProp.Medium, ActivityProp.ModificationTime, ActivityProp.ModifiedBy, ActivityProp.Outcome, ActivityProp.OutcomeLabel, ActivityProp.OutcomeValue, ActivityProp.RelatedEntity, ActivityProp.RelatedEntityId, ActivityProp.Summary])

export type ActivityDetails = 
	ActivityPropId & 
	ActivityPropCreationTime & 
	ActivityPropModificationTime & 
	ActivityPropModifiedBy & 
	ActivityPropDirection & 
	ActivityPropOutcome & 
	ActivityPropOutcomeLabel & 
	ActivityPropOutcomeValue & 
	ActivityPropRelatedEntity & 
	ActivityPropSummary & 
	ActivityPropDescription & 
	ActivityPropMedium

export const ACTIVITY_DETAILS_PROPERTY_NAMES = Object.freeze([ActivityProp.Id, ActivityProp.CreationTime, ActivityProp.ModificationTime, ActivityProp.ModifiedBy, ActivityProp.Direction, ActivityProp.Outcome, ActivityProp.OutcomeLabel, ActivityProp.OutcomeValue, ActivityProp.RelatedEntity, ActivityProp.Summary, ActivityProp.Description, ActivityProp.Medium])

export type ActivityCreate = 
	ActivityPropCustomerId & 
	ActivityPropRelatedEntityId

export const ACTIVITY_CREATE_PROPERTY_NAMES = Object.freeze([ActivityProp.CustomerId, ActivityProp.RelatedEntityId])
